import React from "react";
import { Card } from "@mui/material";
import { styled, Box } from "@mui/system";

const CardRoot = styled(Card, {
  shouldForwardProp: (prop) => prop !== "width" && prop !== "height",
})(({ width, height }) => ({
  height: height || "100%",
  padding: "20px 24px",
  flex: width ? "0 0 auto" : "1 1 250px",
  maxWidth: width || "100%",

  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
}));

const CardHeader = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
}));

const CardTitle = styled("div")(() => ({
  fontSize: "1rem",
  fontWeight: 600,
  lineHeight: 1.3,
  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
}));

const SimpleCard = ({ children, title, subtitle, width, height, sx }) => {
  return (
    <CardRoot
      elevation={0}
      width={width}
      height={height}
      sx={{
        boxShadow: "none",
        border: "1px solid rgba(0, 0, 0, 0.12)",
        ...sx,
      }}
    >
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {subtitle && <Box sx={{ mt: 1 }}>{subtitle}</Box>}
      </CardHeader>

      <Box>{children}</Box>
    </CardRoot>
  );
};

export default SimpleCard;
